import { useTranslation } from "react-i18next";
import { colors } from "../../../data/colors";
import { versionsType } from "../../../data/types/versionsType";
import { getVersionName } from "../functions/getVersionName";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { SetStateAction, useEffect, useRef, useState } from "react";
import { stdObject } from "../../../data/types/stdObject";
import WriteInput from "../../../components/componentModal/WriteInput";
import { startLogin } from "../../Login/functions/startLogin";
import { useMainContext } from "../../../context/MainContext";

const defaultValues = {
  open: false,
  step: "username",
  username: { text: "", type: "text" },
  password: { text: "", type: "password" },
};

export default function MainFooter() {
  const cVersion = process.env.REACT_APP_VERSION as versionsType;
  const nVersion = process.env.REACT_APP_VERSION_NUMBER;
  const dispatch = useDispatch();
  const { setMsg, setWindowValues, setModalData2, closeMsg } = useMainContext();
  const user: any = useSelector((state: RootState) => state.data.user);
  const { t } = useTranslation();
  const [loginModal, setLoginModal] = useState<stdObject>(defaultValues);
  const loginRef = useRef<HTMLInputElement>(null);

  const goNext = async () => {
    switch (loginModal.step) {
      case "username":
        setLoginModal({ ...loginModal, step: "password" });
        break;
      case "password":
        const responseLogin = await startLogin({
          dispatch,
          quickLogin: true,
          loginData: {
            username: loginModal.username.text.trim().toLowerCase(),
            password: loginModal.password.text.trim(),
          },
          cleanData: () => {},
          setMsg,
          setWindowValues,
          closeMsg,
        });
        if (typeof responseLogin === "string" && responseLogin) {
          setMsg("error");
          setModalData2({ label: t(`p.${responseLogin}`) });
        }
        setLoginModal(defaultValues);
        break;
    }
  };

  useEffect(() => {
    if (loginModal.open) {
      loginRef.current?.focus();
    }
  }, [loginModal.open]);

  return (
    <div
      style={{
        backgroundColor: colors.darkGrey,
        padding: 5,
        color: colors.white,
      }}
    >
      <div
        style={{ float: "left", cursor: "pointer" }}
        onClick={() => {
          setLoginModal({
            ...loginModal,
            step: "username",
            username: { ...loginModal.username, text: "" },
            password: { ...loginModal.password, text: "" },
            open: true,
          });
        }}
      >
        {user.NOMUSU}
      </div>
      <div style={{ float: "right" }}>
        {getVersionName({
          name: process.env.REACT_APP_NAME,
          cVersion,
          nVersion,
          t,
        })}
      </div>
      {loginModal.open && (
        <div className="quickLogin">
          <WriteInput
            data={{
              refId: loginRef,
              label: t(`p.${loginModal.step}`),
              type: loginModal[loginModal.step].type,
              value: loginModal[loginModal.step].text,
              onBlur: () => {
                setLoginModal(defaultValues);
              },
              onChange: (v: { target: { value: SetStateAction<string> } }) => {
                setLoginModal({
                  ...loginModal,
                  [loginModal.step]: {
                    ...loginModal[loginModal.step],
                    text: v.target.value,
                  },
                });
              },
              onKeyDown: (e: stdObject) => {
                if (
                  ["Enter", "Tab"].includes(e.key) &&
                  loginModal[loginModal.step].text.trim() !== ""
                ) {
                  e.preventDefault();
                  goNext();
                }
              },
              inputStyle: { width: 160, padding: 10 },
            }}
          />
        </div>
      )}
    </div>
  );
}
